module.exports = {"id":"206198","name":"Dominique Heintz","rating":"78","photo":"./data/images/photos/1/206198.png","club":{"name":"1. FC Cologne","logo":"./data/images/clubs/1.FCCologne.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DominiqueHeintz0.json
// module id = 1137
// module chunks = 0